export enum SocialMedia {
    LINKDIN = 'linkdin',
    GITLAB = 'gitlab',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    TIKTOK = 'tiktok',
}

export enum SocialMediaUrl {
    LINKDIN = 'https://www.linkedin.com/in/tomer-halali-a40235185',
    GITLAB = 'https://gitlab.com/TomerHalali',
    FACEBOOK = 'https://www.facebook.com/TomerHalali',
    INSTAGRAM = 'https://www.instagram.com/tomerhalali',
    TIKTOK = 'https://www.tiktok.com/@tomer.halali',
}

export enum Languages {
    HEBREW = 'he',
    ENGLISH = 'en',
}
